import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteFlight = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, { tripId: string; flightId: number }>({
		mutationFn: async ({ tripId, flightId }) => {
			await api.delete(`/trips/${tripId}/flights/${flightId}`)
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.flights(variables.tripId) })
		},
	})
}
